import React from 'react';
import { enumValue } from '~/util';
import { Notes } from '../Notes';

// Exclude certain gap actions that we only want to see in PCM
const includeActionsFiltered = Object.keys(window.app.enums.note.action).filter((x) => {
    return ![
        enumValue(['note', 'action', 'Gap status changed']),
        enumValue(['note', 'action', 'Gap submitted']),
        enumValue(['note', 'action', 'Review status expired']),
        enumValue(['note', 'action', 'New eSubmission answer']),
        enumValue(['note', 'action', 'eSubmission answer changed']),
        enumValue(['note', 'action', 'eSubmission answer removed']),
        enumValue(['note', 'action', 'Task created']),
        enumValue(['note', 'action', 'Task edited']),
        enumValue(['note', 'action', 'Task status changed']),
        enumValue(['note', 'action', 'Event transferred from source system']),
        enumValue(['note', 'action', 'Event transferred to Zephyr']),
    ].includes(parseInt(x));
});

interface PatientAuditNotesProps {
    enableOpenModal?: boolean;
    entityId: number;
    patient: PatientType;
}
export function PatientAuditNotes({
    enableOpenModal = false,
    entityId,
    patient,
}: PatientAuditNotesProps) {
    return (
        <Notes
            canAdd={false}
            enableOpenModal={enableOpenModal}
            entityId={entityId}
            includeActions={includeActionsFiltered}
            patient={patient}
        />
    );
}
